// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"417":"58a0c106","532":"e1195930","564":"2dcce921","727":"f0007ce8"}[chunkId] + ".chunk.css";
};